<template>
  <v-layout
    class="splash-screen-wrapper"
    fill-height
    align-center
    justify-center
  >
    <v-img :src="$settings?.profile?.logo" max-width="10%" />
  </v-layout>
</template>

<script>
export default {
  name: "SplashScreen",
};
</script>

<style src="./style.scss" lang="scss" scoped />
